// extracted by mini-css-extract-plugin
export default {"landing-page-container":"LandingPageMain_landing-page-container__skIUC"};